// ShortcutHelp.js
// Keyboard shortcut cheat sheet modal
import React from 'react';

const shortcuts = [
  { keys: 'Ctrl+S', desc: 'Save file' },
  { keys: 'Ctrl+P', desc: 'Open command palette' },
  { keys: 'Ctrl+Shift+P', desc: 'Open command palette (global)' },
  { keys: 'Ctrl+W', desc: 'Close tab' },
  { keys: 'Ctrl+1/2', desc: 'Switch split view' },
  { keys: 'Ctrl+Tab', desc: 'Next tab' },
  { keys: 'Ctrl+Shift+Tab', desc: 'Previous tab' },
  { keys: 'Ctrl+/', desc: 'Toggle comment' },
  { keys: 'Ctrl+F', desc: 'Find in file' },
  { keys: 'Ctrl+B', desc: 'Toggle sidebar' },
];

const ShortcutHelp = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0,0,0,0.35)',
      zIndex: 2001,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }} onClick={onClose}>
      <div style={{
        background: '#232323',
        borderRadius: 12,
        boxShadow: '0 4px 32px #0008',
        minWidth: 340,
        maxWidth: 420,
        padding: 32,
        color: '#fff',
      }} onClick={e => e.stopPropagation()}>
        <h2 style={{ marginTop: 0, fontSize: 22, marginBottom: 18 }}>Keyboard Shortcuts</h2>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {shortcuts.map(s => (
            <li key={s.keys} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
              <span style={{ fontWeight: 500 }}>{s.desc}</span>
              <span style={{ background: '#181818', borderRadius: 6, padding: '2px 10px', fontFamily: 'monospace', fontSize: 15 }}>{s.keys}</span>
            </li>
          ))}
        </ul>
        <div style={{ textAlign: 'right', marginTop: 18 }}>
          <button onClick={onClose} style={{ background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 18px', fontWeight: 500, cursor: 'pointer' }}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default ShortcutHelp;
